import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Chicago">
                                <h1>Software Development Company in <span>Chicago</span></h1>
                            </div>
                            <p className="main_para">We are an experienced software development company in Chicago
                                creating and delivering high-end digital products for enterprises across different
                                industry verticals, including retail, healthcare, logistics, on-demand, music, real
                                estate, and more.</p>
                            <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;